<template>
  <v-flex xs12 style="position: relative">
    <v-flex v-if="loading" style="position: absolute; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; z-index: 9;">
      <v-progress-circular :size="70" :width="7" color="accent" indeterminate></v-progress-circular>
    </v-flex>
    <v-flex style="padding: 40px 5%" v-if="this.$route.query && this.$route.query.display && this.$route.query.display === 'search' && (!$route.query.type || $route.query.type !== 'recommended')" :class="loading ? 'blurClass' : ''">We found {{projectsLength}} search results for <b style="text-transform: capitalize">"{{getSearchCriteria}}"</b>.</v-flex>
    <v-flex style="padding: 40px 5%; text-transform: capitalize; font-size: 24px; font-weight: 700" v-if="this.$route.query && this.$route.query.display && this.$route.query.display === 'category'" :class="loading ? 'blurClass' : ''">{{stat}} Projects</v-flex>
    <v-flex style="padding: 40px 5%; text-transform: capitalize; font-size: 24px; font-weight: 700" v-if="this.$route.query && this.$route.query.display && this.$route.query.display === 'search' && $route.query.type && $route.query.type === 'recommended'" :class="loading ? 'blurClass' : ''">Recommended Projects</v-flex>
    <v-flex class="searchResults" id="searchResults" v-resize="onResize" :class="loading ? 'blurClass' : ''">
      <v-flex v-for="(item, index) in projects" :key="index" @click="togglePanelDisplay(item, index)" :style="item.type && item.type === 'panel' ? 'width: 100%' : 'flex:none'">
        <div class="projectPanel primary mb-2" v-if="item.type && item.type === 'panel'" :style="'width: ' + item.width + 'px'">
          <ProjectPanel v-on:manage-project="manageProject(item)" v-on:manage-users="manageUsers(item)" v-on:subscribe="subscribeToProject" v-bind:options="{project: item}"></ProjectPanel>
        </div>
        <div v-else class="projectCard" :style="{ 'background-image': 'url(' + item.config.unsplashImageUrl + ')' }">
          <div class="projectOverlay"></div>
          <div class="projectInfo">
            <div class="projectName secondary--text">{{item.name}}</div>
            <div class="projectOrganization secondary--text">{{getOrganizationName(item)}}</div>
          </div>
          <div class="projectArrow secondary--text" v-if="openIndex === index"><div class="projectArrowDown"></div></div>
        </div>
      </v-flex>
      <v-flex xs12 py-3 style="display: flex; justify-content: center" v-if="totalPages > 0">
        <v-pagination :total-visible="7" @input="handlePagination" class="searchPagination" light v-model="pageNumber" :length="totalPages" ></v-pagination>
      </v-flex>
    </v-flex>
    <v-dialog
      v-if="isLoggedIn && selectedProject"
      v-model="subscribeDialog"
      persistent
      scrollable
      fullscreen
      transition="dialog-transition">
      <Subscribe v-on:close-subscribe-dialog="subscribeDialog = false; selectedProject = null" v-bind:options="{project: selectedProject, planId: selectedPlanId}"></Subscribe>
    </v-dialog>
    <v-dialog
      v-if="selectedProject"
      v-model="manageDialog"
      persistent
      fullscreen
      transition="dialog-transition"
    >
      <ManageProject v-on:close-manage-dialog="manageDialog = false; selectedProject = null" v-bind:options="{project: selectedProject}"></ManageProject>
    </v-dialog>
  </v-flex>
</template>

<style>
  .blurClass{
    -webkit-filter: blur(5px);
    filter: blur(5px);
  }
  .searchPagination .v-pagination__item{
    background-color: transparent !important;
    box-shadow: none;
    font-size: 22px;
    font-weight: 300;
  }
  .searchPagination .v-pagination__item.v-pagination__item--active{
    color: #011E41 !important;
    font-weight: 800;
  }
  .searchPagination .v-pagination__navigation{
    box-shadow: none;
  }
  .searchPagination .v-pagination__navigation .v-icon{
    color: #011E41 !important;
    font-size: 34px;
  }
  .searchPagination .v-pagination__navigation.v-pagination__navigation--disabled .v-icon{
    color: #B2BBC5 !important;
  }
  .projectPanel{
    height: 500px;
    position: relative;
    transition: 200ms all ease;
  }
  .searchResults{
    padding: 0 5%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }
  .projectArrow{
    position: absolute;
    top: 100%;
    margin-top: 5px;
    left: 0;
    right: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    z-index: 9
  }
  .projectArrowDown{
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-top: 15px solid white;
  }
  .projectCard{
    position: relative;
    width: 260px;
    height: 160px;
    flex: none;
    margin-bottom: 5px;
    margin-right: 5px;
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
  }
  .projectTitle{
    width: 100%;
    text-align: center;
    font-size: 36px;
    font-weight: 800;
  }
  .projectsCards{
    position: relative;
    width: 100%;
  }
  .projectContainer{
    position: relative;
    flex: none;
  }
  .projectOverlay{
    background: #000000;
    opacity: 0.5;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 4;
  }
  .projectInfo{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 25px;
    z-index: 6;
  }
  .projectName{
    font-size: 18px;
    font-weight: 700;
  }
  .projectOrganization{
    font-weight: 500;
    font-size: 12px;
  }
</style>

<script>
import axios from 'axios'
import ProjectPanel from './appElements/ProjectPanel.vue'
import Subscribe from './Subscribe.vue'
import { mapGetters, mapMutations } from 'vuex'
import ManageProject from './appElements/ManageProject.vue'

export default{
  data () {
    return {
      searchInput: '',
      category: 'All Categories',
      categories: [],
      projects: [],
      pageNumber: 1,
      openIndex: null,
      panelIndex: null,
      selectedProject: null,
      totalPages: 1,
      order: 'DESC',
      selectedProjectId: null,
      subscribeDialog: false,
      selectedPlanId: null,
      orgProjectIds: [],
      projectsLength: 0,
      resultsPage: 0,
      pageSize: 20,
      stat: '',
      trendingTimePeriod: 7,
      dialogType: 'projects',
      manageDialog: false,
      loading: false
    }
  },
  mounted () {
    this.pageNumber = 1
    this.order = this.$route.query.order
    if (this.$route.query.display && this.$route.query.display === 'search') {
      this.searchInput = this.$route.query.input
      if (Array.isArray(this.$route.query.category) && this.$route.query.category.length > 0) {
        this.categories = this.$route.query.category
      } else if (!Array.isArray(this.$route.query.category) && this.$route.query.category !== '') {
        this.categories = [this.$route.query.category]
      }
      this.getSearchData()
    } else if (this.$route.query.display && this.$route.query.display === 'category') {
      this.stat = this.$route.query.type
      this.searchInput = ''
      if (this.$route.query.category && Array.isArray(this.$route.query.category) && this.$route.query.category.length > 0) {
        this.categories = this.$route.query.category
      } else if (this.$route.query.category && !Array.isArray(this.$route.query.category) && this.$route.query.category !== '') {
        this.categories = [this.$route.query.category]
      }
      this.getStatData()
    }
    if (this.$route.query.projectId) {
      this.selectedProjectId = Number(this.$route.query.projectId)
      this.orgProjectIds = [this.selectedProjectId]
    }
    if (this.$route.query.planId) {
      this.planId = Number(this.$route.query.planId)
      this.subscribeToProject({projectId: this.selectedProjectId, planId: this.planId})
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({
      getUserOrganization: 'getUserOrganization',
      getPlanById: 'getPlanById',
      getProjectCategories: 'getProjectCategories'
    }),
    organizationUsers () {
      if (this.currentUser) {
        var users = JSON.parse(JSON.stringify(this.getUserOrganization.users))
        var self = this
        var index = users.findIndex(function (user) {
          return user.id === self.currentUser.id
        })
        users.splice(index, 1)
        if (users.length > 0) {
          var inactiveUsers = users.find(item => { return item.active === false })
          if (Array.isArray(inactiveUsers) && inactiveUsers.length > 0) {
            for (var i = 0; i < inactiveUsers.length; i++) {
              var userIndex = users.findIndex(function (user) {
                return user.id === inactiveUsers[i].id
              })
              users.splice(userIndex, 1)
            }
          } else if (inactiveUsers.id) {
            var inactiveUserIndex = users.findIndex(function (user) {
              return user.id === inactiveUsers.id
            })
            users.splice(inactiveUserIndex, 1)
          }
        }
        return users
      }
    },
    organizationProjects () {
      if (this.getUserOrganization) {
        var projects = JSON.parse(JSON.stringify(this.getUserOrganization.projects))
        var pendingProjects = projects.find(item => { return item.status !== 'active' })
        if (Array.isArray(pendingProjects)) {
          for (var i = 0; i < pendingProjects.length; i++) {
            var projectIndex = projects.findIndex(function (project) {
              return project.id === pendingProjects[i].id
            })
            projects.splice(projectIndex, 1)
          }
        } else if (pendingProjects.id) {
          var inactiveProjectIndex = projects.findIndex(function (project) {
            return project.id === pendingProjects.id
          })
          projects.splice(inactiveProjectIndex, 1)
        }
        var currentProject = this.projects.find(item => { return item.id === this.selectedProjectId })
        projects.push(currentProject)
        return projects
      }
    },
    getSearchCriteria () {
      if (this.searchInput && this.searchInput !== '') {
        return this.searchInput
      } else if (this.categories && (this.categories.length === 0 || this.categories.length === this.getProjectCategories.length)) {
        return 'All categories'
      } else if (this.categories) {
        var criteria = this.categories[0]
        for (var c = 1; c < this.categories.length; c++) {
          criteria += ', ' + this.categories[c]
        }
        return criteria
      }
      return ''
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    manageProject (project) {
      this.selectedProject = project
      this.manageDialog = true
    },
    manageUsers (project) {
      this.selectedProject = project
      this.dialogType = 'users'
      this.subscribeDialog = true
    },
    handlePagination (value) {
      if (this.panelIndex) {
        this.projects.splice(this.projects.findIndex(function (project) { return project.type && project.type === 'panel' }), 1)
        this.panelIndex = null
      }
      this.openIndex = null
      this.selectedProjectId = -1
      if (this.$route.query.display && this.$route.query.display === 'search') {
        this.getSearchData()
      } else {
        this.getStatData()
      }
    },
    getOrganizationData () {
      axios.all([this.$store.dispatch('getOrganizationsWithAllById', {id: this.getUserOrganization.id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.$store.commit('setUserOrganization', response.data.payload)
        } else {
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    subscribeToProject (subscriptionObject) {
      this.subscribeDialog = true
      this.selectedProject = this.projects.find(item => { return item.id === subscriptionObject.projectId })
      this.selectedPlanId = subscriptionObject.planId
    },
    onResize () {
      if (document.getElementById('searchResults')) {
        if (this.panelIndex) {
          this.projects.splice(this.projects.findIndex(function (project) { return project.type && project.type === 'panel' }), 1)
          this.panelIndex = null
        }
        this.openIndex = null
        this.selectedProjectId = -1
        var numberOfElements = Math.floor((document.getElementById('searchResults').offsetWidth - (document.getElementById('searchResults').offsetWidth * 0.1)) / 265)
        var getData = false
        if (numberOfElements % 3 === 0 || numberOfElements % 6 === 0) {
          if (this.pageSize !== 18) {
            this.pageSize = 18
            getData = true
          }
        } else {
          if (this.pageSize !== 20) {
            this.pageSize = 20
            getData = true
          }
        }
        if (getData && this.projects.length > 0) {
          if (this.$route.query.display && this.$route.query.display === 'search') {
            this.getSearchData()
          } else if (this.$route.query.display && this.$route.query.display === 'category') {
            this.getStatData()
          }
        }
      }
    },
    togglePanelDisplay (project, index) {
      if ((!project.type || project.type !== 'panel') && document.getElementById('searchResults')) {
        if (index !== this.openIndex) {
          if (this.panelIndex) {
            index = this.panelIndex < index ? index - 1 : index
            this.projects.splice(this.projects.findIndex(function (project) { return project.type && project.type === 'panel' }), 1)
          }
          this.openIndex = index
          var numberOfElements = Math.floor((document.getElementById('searchResults').offsetWidth - (document.getElementById('searchResults').offsetWidth * 0.1)) / 265)
          this.panelIndex = Math.ceil((index + 1) / numberOfElements) * numberOfElements
          var projectDetails = JSON.parse(JSON.stringify(project))
          projectDetails.type = 'panel'
          projectDetails.width = (265 * numberOfElements) - 5
          var self = this
          setTimeout(function () {
            self.projects.splice(self.panelIndex, 0, projectDetails)
          }, 2)
        } else {
          if (this.$route.query.path || this.$route.projectId || this.$route.query.planId) {
            this.$router.push({query: {input: this.searchInput, category: this.categories, display: 'search', order: this.order}})
          }
          while (this.projects.findIndex(function (project) { return project.type && project.type === 'panel' }) !== -1) {
            this.projects.splice(this.projects.findIndex(function (project) { return project.type && project.type === 'panel' }), 1)
          }
          this.panelIndex = null
          this.openIndex = null
          this.selectedProjectId = -1
        }
      }
    },
    getOrganizationName (project) {
      var organization = project.organizations.find(item => { return item.id === project.createdByOrganizationId })
      if (organization) {
        return organization.name
      }
      return ''
    },
    getSearchData () {
      if (!this.searchInput || this.searchInput === '') {
        if (this.categories.length === 0 || this.categories.length === this.getProjectCategories.length) {
          this.getProjects()
        } else {
          this.getProjectsByCategory()
        }
      } else if (this.categories.length === 0 || this.categories.length === this.getProjectCategories.length) {
        this.getProjectsFuzzy()
      } else {
        this.getProjectsFuzzyByCategory()
      }
    },
    getProjects () {
      this.loading = true
      this.projects = []
      axios.all([this.$store.dispatch('getProjectsWithAllPublic', '?sortBy=_date_added&projectStatus=Active&order=' + this.order + '&pageSize=' + this.pageSize + '&pageNumber=' + encodeURIComponent(this.pageNumber))]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          if (response.data.payload && response.data.payload.length > 0) {
            this.projects = response.data.payload
            axios.all([this.$store.dispatch('getProjectsWithAllPublicCount', '?projectStatus=Active')]).then(axios.spread((response) => {
              if (response.data.status === 'SUCCESS') {
                this.loading = false
                this.projectsLength = response.data.payload
                this.totalPages = Math.ceil(response.data.payload / this.pageSize)
                if (this.selectedProjectId !== -1) {
                  var project = this.projects.find(item => { return item.id === this.selectedProjectId })
                  if (project) {
                    var projectIndex = this.projects.findIndex(function (item) { return item.id === project.id })
                    this.togglePanelDisplay(project, projectIndex)
                  } else {
                    if (this.openIndex === null) {
                      this.togglePanelDisplay(this.projects[0], 0)
                    }
                  }
                } else {
                  if (this.openIndex === null) {
                    this.togglePanelDisplay(this.projects[0], 0)
                  }
                }
              } else {
                this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                this.loading = false
              }
            })).catch((err) => {
              this.notify({message: 'Something went wrong while connecting to the server.', show: true})
              this.loading = false
              console.log(err)
            })
          } else if (response.data.payload.length === 0) {
            this.totalPages = 0
            this.projectsLength = 0
            this.loading = false
          }
        } else {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          this.loading = false
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.loading = false
        console.log(err)
      })
    },
    getProjectsFuzzy () {
      this.loading = true
      this.projects = []
      axios.all([this.$store.dispatch('getProjectsPublicWithAllFuzzy', {searchValue: this.searchInput, query: '?sortBy=_date_added&projectStatus=Active&order=' + this.order + '&pageSize=' + this.pageSize + '&pageNumber=' + encodeURIComponent(this.pageNumber)})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          if (response.data.payload && response.data.payload.length > 0) {
            this.projects = response.data.payload
            axios.all([this.$store.dispatch('getProjectsPublicFuzzyCount', {searchValue: this.searchInput, query: '?projectStatus=Active'})]).then(axios.spread((response) => {
              if (response.data.status === 'SUCCESS') {
                this.loading = false
                this.projectsLength = response.data.payload
                this.totalPages = Math.ceil(response.data.payload / this.pageSize)
                if (this.selectedProjectId !== -1) {
                  var project = this.projects.find(item => { return item.id === this.selectedProjectId })
                  if (project) {
                    var projectIndex = this.projects.findIndex(function (item) { return item.id === project.id })
                    this.togglePanelDisplay(project, projectIndex)
                  } else {
                    if (this.openIndex === null) {
                      this.togglePanelDisplay(this.projects[0], 0)
                    }
                  }
                } else {
                  if (this.openIndex === null) {
                    this.togglePanelDisplay(this.projects[0], 0)
                  }
                }
              } else {
                this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                this.loading = false
              }
            })).catch((err) => {
              this.notify({message: 'Something went wrong while connecting to the server.', show: true})
              this.loading = false
              console.log(err)
            })
          } else if (response.data.payload.length === 0) {
            this.totalPages = 0
            this.projectsLength = 0
            this.loading = false
          }
        } else {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          this.loading = false
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.loading = false
        console.log(err)
      })
    },
    getProjectsByCategory () {
      this.loading = true
      this.projects = []
      var categoryQuery = ''
      this.categories.forEach(function (cat) {
        categoryQuery += ('&category=' + encodeURIComponent(cat))
      })
      axios.all([this.$store.dispatch('getProjectsWithAllPublic', '?sortBy=_date_added&projectStatus=Active&order=' + this.order + categoryQuery + '&pageSize=' + this.pageSize + '&pageNumber=' + encodeURIComponent(this.pageNumber))]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.loading = false
          if (response.data.payload && response.data.payload.length > 0) {
            this.lastPage = response.data.payload.length < 20
            this.projects = response.data.payload
            axios.all([this.$store.dispatch('getProjectsWithAllPublicCount', '?projectStatus=Active' + categoryQuery)]).then(axios.spread((response) => {
              if (response.data.status === 'SUCCESS') {
                this.projectsLength = response.data.payload
                this.totalPages = Math.ceil(response.data.payload / this.pageSize)
                if (this.selectedProjectId !== -1) {
                  var project = this.projects.find(item => { return item.id === this.selectedProjectId })
                  if (project) {
                    var projectIndex = this.projects.findIndex(function (item) { return item.id === project.id })
                    this.togglePanelDisplay(project, projectIndex)
                  } else {
                    if (this.openIndex === null) {
                      this.togglePanelDisplay(this.projects[0], 0)
                    }
                  }
                } else {
                  if (this.openIndex === null) {
                    this.togglePanelDisplay(this.projects[0], 0)
                  }
                }
              } else {
                this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                this.loading = false
              }
            })).catch((err) => {
              this.notify({message: 'Something went wrong while connecting to the server.', show: true})
              this.loading = false
              console.log(err)
            })
          } else if (response.data.payload.length === 0) {
            this.totalPages = 0
            this.projectsLength = 0
            this.loading = false
          }
        } else {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          this.loading = false
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.loading = false
        console.log(err)
      })
    },
    getProjectsFuzzyByCategory () {
      this.loading = true
      this.projects = []
      var categoryQuery = ''
      this.categories.forEach(function (cat) {
        categoryQuery += ('&category=' + encodeURIComponent(cat))
      })
      axios.all([this.$store.dispatch('getProjectsPublicWithAllFuzzy', {searchValue: this.searchInput, query: '?sortBy=_date_added&projectStatus=Active&order=' + this.order + categoryQuery + '&pageSize=' + this.pageSize + '&pageNumber=' + encodeURIComponent(this.pageNumber)})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.loading = false
          if (response.data.payload && response.data.payload.length > 0) {
            this.projects = response.data.payload
            categoryQuery = categoryQuery.substr(1)
            axios.all([this.$store.dispatch('getProjectsPublicFuzzyCount', {searchValue: this.searchInput, query: '?projectStatus=Active&' + categoryQuery})]).then(axios.spread((response) => {
              if (response.data.status === 'SUCCESS') {
                this.projectsLength = response.data.payload
                this.totalPages = Math.ceil(response.data.payload / this.pageSize)
                if (this.selectedProjectId !== -1) {
                  var project = this.projects.find(item => { return item.id === this.selectedProjectId })
                  if (project) {
                    var projectIndex = this.projects.findIndex(function (item) { return item.id === project.id })
                    this.togglePanelDisplay(project, projectIndex)
                  } else {
                    if (this.openIndex === null) {
                      this.togglePanelDisplay(this.projects[0], 0)
                    }
                  }
                } else {
                  if (this.openIndex === null) {
                    this.togglePanelDisplay(this.projects[0], 0)
                  }
                }
              } else {
                this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                this.loading = false
              }
            })).catch((err) => {
              this.notify({message: 'Something went wrong while connecting to the server.', show: true})
              this.loading = false
              console.log(err)
            })
          } else if (response.data.payload.length === 0) {
            this.totalPages = 0
            this.projectsLength = 0
            this.loading = false
          }
        } else {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          this.loading = false
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.loading = false
        console.log(err)
      })
    },
    getStatData () {
      this.loading = true
      var timePeriodStartQueryString = ''
      var query = ''
      var countQuery = ''
      this.projects = []
      if (this.stat === 'trending') {
        var today = new Date()
        var todayQueryString = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
        var timePeriodStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - this.trendingTimePeriod)
        timePeriodStartQueryString = timePeriodStart.getFullYear() + '-' + (timePeriodStart.getMonth() + 1) + '-' + timePeriodStart.getDate()
        query = '?sortBy=_total_subscriptions%20desc,_date_added%20desc&projectStatus=Active&pageSize=' + this.pageSize + '&fromDate=' + timePeriodStartQueryString + '&toDate=' + todayQueryString + '&pageNumber=' + encodeURIComponent(this.pageNumber)
        countQuery = '?fromDate=' + timePeriodStartQueryString + '&projectStatus=Active&toDate=' + todayQueryString
      } else if (this.stat === 'popular') {
        query = '?sortBy=_total_subscriptions%20desc,_date_added%20desc&projectStatus=Active&pageSize=' + this.pageSize + '&pageNumber=' + encodeURIComponent(this.pageNumber)
        countQuery = '?fromDate=' + timePeriodStartQueryString + '&projectStatus=Active&toDate=' + todayQueryString
      }
      if (query !== '') {
        axios.all([this.$store.dispatch('getProjectsWithAllAndStatsPublic', query)]).then(axios.spread((response) => {
          if (response.data.status === 'SUCCESS') {
            this.loading = false
            if (response.data.payload && response.data.payload.length > 0) {
              this.projects = response.data.payload
              axios.all([this.$store.dispatch('getProjectsWithAllPublicCount', countQuery)]).then(axios.spread((response) => {
                if (response.data.status === 'SUCCESS') {
                  this.projectsLength = response.data.payload
                  this.totalPages = Math.ceil(response.data.payload / this.pageSize)
                  if (this.selectedProjectId !== -1) {
                    var project = this.projects.find(item => { return item.id === this.selectedProjectId })
                    if (project) {
                      var projectIndex = this.projects.findIndex(function (item) { return item.id === project.id })
                      this.togglePanelDisplay(project, projectIndex)
                    } else {
                      if (this.openIndex === null) {
                        this.togglePanelDisplay(this.projects[0], 0)
                      }
                    }
                  } else {
                    if (this.openIndex === null) {
                      this.togglePanelDisplay(this.projects[0], 0)
                    }
                  }
                } else {
                  this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                  this.loading = false
                }
              })).catch((err) => {
                this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                this.loading = false
                console.log(err)
              })
            } else if (response.data.payload.length === 0) {
              this.totalPages = 0
              this.projectsLength = 0
              this.loading = false
            }
          } else {
            this.notify({message: 'Something went wrong while connecting to the server.', show: true})
            this.loading = false
          }
        })).catch((err) => {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          this.loading = false
          console.log(err)
        })
      }
    }
  },
  watch: {
    '$route.query': function (newval, oldval) {
      this.pageNumber = 1
      this.order = this.$route.query.order
      if (this.$route.query.display && this.$route.query.display === 'search') {
        this.searchInput = this.$route.query.input
        if (Array.isArray(this.$route.query.category) && this.$route.query.category.length > 0) {
          this.categories = this.$route.query.category
        } else if (!Array.isArray(this.$route.query.category) && this.$route.query.category !== '') {
          this.categories = [this.$route.query.category]
        }
        this.getSearchData()
      } else if (this.$route.query.display && this.$route.query.display === 'category') {
        this.stat = this.$route.query.type
        this.searchInput = ''
        if (Array.isArray(this.$route.query.category) && this.$route.query.category.length > 0) {
          this.categories = this.$route.query.category
        } else if (!Array.isArray(this.$route.query.category) && this.$route.query.category !== '') {
          this.categories = [this.$route.query.category]
        }
        this.getStatData()
      }
      if (this.$route.query.projectId) {
        this.selectedProjectId = Number(this.$route.query.projectId)
      } else {
        this.selectedProjectId = null
      }
      if (this.$route.query.planId) {
        this.planId = Number(this.$route.query.planId)
        this.subscribeDialog = true
        this.orgProjectIds = this.orgProjectIds = [this.selectedProjectId]
      } else {
        this.planId = null
        this.subscribeDialog = false
        this.orgProjectIds = this.orgProjectIds = [this.selectedProjectId]
      }
    }
  },
  components: {
    ProjectPanel,
    Subscribe,
    ManageProject
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Search.vue